/** Стан списку, з яким модуль відкривається з верхнього меню, закріплених чи «Усіх модулів» (UIUX layout/left-menu, прототип v4 openModule). */
import type { IListViewState } from '@platform/core/types';

/**
 * Зміна стану пункту «Усі …»: подання «Таблиця», без пошуку, тегу, швидкого фільтра, колонкових фільтрів, вкладки етапу й сортування,
 * перша сторінка. Розмір сторінки й вибране збережене подання лишаються — прототип їх теж не скидає.
 */
export const LANDING_STATE: Partial<IListViewState> = {
  view: 'table', search: '', tagFilter: [], quickFilter: 'all', columnFilter: '', stage: null, sort: '', page: 1,
};
